
import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

const StatCard = ({ title, value, change, icon: Icon, color }) => {
  const gradients = {
    "bg-blue-500": ["#e8efff", "#f5f8ff"],
    "bg-purple-500": ["#f3e8ff", "#f8f2ff"], 
    "bg-green-500": ["#e8ffe9", "#f2fff3"],
    "bg-yellow-500": ["#fff9e8", "#fffcf2"]
  };

  const [startColor, endColor] = gradients[color] || ["#F5F5F5", "#FFFFFF"];

  return (
    <div className="bg-white/80 p-6 rounded-lg shadow-md relative overflow-hidden backdrop-blur-sm">
      <div className="absolute inset-0" style={{
        background: `linear-gradient(135deg, ${startColor} 0%, ${endColor} 100%)`
      }}></div>
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-700 truncate max-w-[80%]">{title}</h3>
          <Icon size={24} className="text-blue-500 flex-shrink-0" />
        </div>
        <p className="text-3xl font-bold text-gray-800 mb-2 truncate">{value}</p>
        <p className={`flex items-center text-sm truncate ${change >= 0 ? 'text-green-500' : 'text-red-500'}`}>
          {change >= 0 ? <ArrowUpRight size={16} /> : <ArrowDownRight size={16} />}
          <span className="ml-1">{Math.abs(change)}% from last month</span>
        </p>
      </div>
    </div>
  );
};

export default StatCard;
